import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import isAlphanumeric from 'is-alphanumeric'
import axios from 'axios'
import { connect } from 'react-redux'

import Content from '../../components/Content/Content'
import Input from '../../components/UI/Input/Input'
import Button from '../../components/UI/Button/Button'
import Modal from '../../components/UI/Modal/Modal'
import Question from '../../components/UI/Question/Question'
import SingleLineSpinner from '../../components/UI/SingleLineSpinner/SingleLineSpinner'
import classes from './Bind.css'
import * as actions from '../../store/actions/index';

class Bind extends Component {

    render() {
        return (
            <Content>
                <div>
                    123
                </div>
            </Content>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(null, mapDispatchToProps)(withRouter(Bind))


// WEBPACK FOOTER //
// ./src/containers/Bind/Bind.js